// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"fK","bottomColumnWapper":"fK","bottom-column-panel":"fL","bottomColumnPanel":"fL"};